export default __webpack_public_path__ + "static/og_image-30c10dd2c77b358c85bec565ae0f72c4.png";